










































































import Vue from "vue";
import PhoneSMS from "@/components/campaign/PhoneSMS.vue";
import PhoneSMSContent from "@/components/campaign/PhoneSMSContent.vue";
import TableSpecialCharacters from "@/components/campaign/TableSpecialCharacters.vue";
import { MessageTemplate } from "@/models";
import { campaignRules } from "@/rules/campaign.rules";
import UtilsService from "@/services/UtilsService";
export default Vue.extend({
  components: { PhoneSMS, PhoneSMSContent, TableSpecialCharacters },
  props: {
    campaign: {
      type: Object,
    },
    templates: Array,
  },
  data() {
    return {
      rules: { ...campaignRules.attr },
      templateOptions:
        (this.templates &&
          this.templates.map((template: any) => ({
            label: template.text,
            value: template.text,
          }))) ||
        [],
      template: null,
    };
  },
  watch: {
    template(val) {
      this.$emit("update", { textMessage: val });
    },
    templates(val: MessageTemplate[]) {
      this.templateOptions = val.map((template) => ({
        label: template.text,
        value: template.text,
      })) as any;
    },
  },
});
